import dayjs from "dayjs";
import { forwardRef, useEffect, useState } from "react";
import { useWebsite } from "../../../context/WebsiteContext";

const BookingHtml = ({ item, index }) => {

  return (<div key={item?.id} className="delivery-note">

    <div className="row space-between drivername">
      <strong>{item?.delivery_driver?.name}</strong>
      <strong>{dayjs(item?.delivery_driver?.delivered_date).format('dddd, D MMM YYYY')}</strong>
    </div>

    <table className="table">
      <thead>
        <tr>
          <th>SL No.</th>
          <th>Booking Ref.</th>
          <th>{item?.recipient_details?.name}</th>
          <th>Delivery Items</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{index + 1}</td>
          <td>{item?.booking_id}</td>
          <td>
            {item?.recipient_details?.address}
            <br />
            {item?.recipient_details?.phone}
          </td>
          <td rowSpan={2}>
            <table class="ditemtable" style={{ width: '100%' }} cellSpacing={3}>
              <tr>
                <td>

                  {item?.products2?.map(i => {
                    return (<div style={{ border: '1px solid black', margin: '5px 0', padding: '5px' }}>
                      <strong>{i?.item_id} - {i?.product_title}</strong>
                      <p>{i?.status_text !== "" ? i.status_text : item?.status_text}</p>
                    </div>)
                  })}

                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td>
            <strong>Delivery Notes:</strong>
            <p>{item?.delivery_notes ? item?.delivery_notes : '-'}</p>
          </td>
        </tr>
      </tbody>
    </table>

  </div >)
};


export const ComponentToPrint = forwardRef((props, ref) => {
  const [bookingData, setBookingData] = useState([]);

  console.log('props');
  console.log(props);

  useEffect(() => {
    /*let newBookingData = props?.bookingData?.map(i => {
      if (i?.delivery_driver?.driver_id === props?.driver_id) {
        return i;
      }
      return null;
    });

    newBookingData = newBookingData?.filter(i => i !== null);*/

    setBookingData(props?.bookingData);
  }, [props]);

  const { websiteData } = useWebsite();

  const companyName = websiteData?.company_name || "Ezy Freight Logistics";
  const companyAddress = websiteData?.company_address || "";
  const companyPhone = websiteData?.phone || "";

  return (<div ref={ref} style={{ padding: "50px" }}>
    <div className="print-wrapper">

      <div className="header">
        <div className="border-box">
          <h2 style={{ margin: '3px 0' }}>{companyName}</h2>
          <h3 style={{ margin: '2px 0' }}>DELIVERY NOTE</h3>
          <p>{companyAddress} </p>
          <p>Tel: {companyPhone}</p>
        </div>
      </div>

      {bookingData?.map((item, index) => {
        return <BookingHtml item={item} bookingData={bookingData} index={index} />
      })}

      {/* Styles */}
      <style>{`
        body {
          font-family: Arial, sans-serif;
        }

        .print-wrapper {
          padding: 20px;
        }

        .delivery-note {
          padding: 10px;
          margin-bottom: 25px;
        }

        .border-box {
          border: 2px solid #000;
          padding: 5px;
          text-align: center;
        }

        .header h2 {
          margin: 0;
          font-size: 18px;
        }

        .header h3 {
          margin: 0 0 3px 0;
          font-size: 14px;
        }

        .header p {
          margin: 2px 0;
          font-size: 11px;
        }

        .row {
          display: flex;
          margin: 10px 0;
        }

        .space-between {
          justify-content: space-between;
        }

        .table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 10px;
        }

        .table th {
          padding: 6px;
          font-size: 16px;
          vertical-align: top;
          text-align: left;
        }

        .table td {
          padding: 6px;
          font-size: 15px;
          vertical-align: top;
          text-align: left;
        }

        .total {
          margin-top: 10px;
        }

        .center {
          text-align: center;
          margin-top: 10px;
        }

        .section {
          margin-top: 10px;
        }

        .drivername{
          font-size: 20px;
          border-top: 1px solid #000;
          border-bottom: 1px solid #000;
          padding: 5px 0;
        }

        @media print {
          body {
            margin: 0;
          }

          .delivery-note {
            page-break-inside: avoid;
          }
        }
      `}</style>

    </div>
  </div>);
});